<template>
  <div
    class="page-header"
    :class="[
      sizeClass,
      {
        'page-header--divider': divider,
      },
    ]"
  >
    <div class="page-header__left">
      <div class="page-header__title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div v-if="subtitle || $slots.subtitle" class="page-header__subtitle">
        <slot name="subtitle">{{ subtitle }}</slot>
      </div>
    </div>

    <div v-if="$slots.actions" class="page-header__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import type { PropType } from 'vue'

type HeaderSize = 'page' | 'card'

export default defineComponent({
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    size: {
      type: String as PropType<HeaderSize>,
      default: 'page',
    },
    divider: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const sizeClass = computed(() => `page-header--${props.size}`)
    return { sizeClass }
  },
})
</script>

<style scoped lang="less">
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--app-gap-sm);
  width: 100%;

  &--divider {
    padding-bottom: 12px;
    border-bottom: 1px solid var(--app-border-color);
  }

  &__left {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    min-width: 0;
    display: flex;
    align-items: center;
    gap: var(--app-gap-xs);
    color: var(--app-text-regular);
    line-height: 1.2;
    font-weight: 600;

    :deep(> *) {
      min-width: 0;
    }
  }

  &__subtitle {
    color: var(--app-text-secondary);
    font-size: 13px;
    line-height: 1.2;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--app-gap-xs);
    flex-shrink: 0;
  }

  &--page &__title {
    font-size: 18px;
  }

  &--card &__title {
    font-size: 16px;
  }
}
</style>
